import dayjs from 'dayjs';
import { VisitorPassVerifyResponse } from 'services/visitor-passes/visitor-passes.service';

export const isReused = (verify?: VisitorPassVerifyResponse): boolean => (verify?.use_count ?? 0) > 0;

export const summarizeUses = (verify: VisitorPassVerifyResponse): { count: string; last: string; cap?: string } => {
    const count = verify.use_count ?? 0;
    const lines: { count: string; last: string; cap?: string } = {
        count: `Ya ingresó ${count} ${count === 1 ? 'vez' : 'veces'}`,
        last: '',
    };
    if (verify.last_use_at) {
        const when = dayjs(verify.last_use_at);
        const day = when.isSame(dayjs(), 'day') ? 'hoy' : when.format('DD/MM');
        lines.last = verify.last_guard_name
            ? `la última ${day} ${when.format('HH:mm')}, validada por ${verify.last_guard_name}`
            : `la última ${day} ${when.format('HH:mm')}`;
    }
    if (verify.max_uses) {
        lines.cap = `uso ${count + 1} de ${verify.max_uses}`;
    }
    return lines;
};
